
export default {
  components: {
  },
  data () {
    return {
      documentList: [],
    };
  },
  mounted () {
    this.$root.$on('filterResponse', (data) => {
      this.tasks = data;
    });
  },
};
